export default "__VITE_ASSET__44d51fd1__"